import { FunctionComponent, useEffect } from 'react';

import { SmallTitle, StandardText, Text } from 'chime-ui/components/Typography';
import { colors } from 'chime-ui/system/colors';

import { useUserContext } from 'hooks/useUserContext';

import { trackPayAnyoneClaimInfoPageViewed } from 'utils/segment/trackingEvents';

import ClaimInfoBase from '../ClaimInfoBase';

const PayAnyoneClaimInfo: FunctionComponent = () => {
  const [userData] = useUserContext();
  const { amount, publicId } = userData;

  useEffect(() => {
    trackPayAnyoneClaimInfoPageViewed(publicId);
  }, [publicId]);

  return (
    <ClaimInfoBase claimCTACopy={`Claim $${amount}`}>
      <SmallTitle>
        Let&apos;s get{' '}
        <Text bold color={colors.darkGreen}>
          ${amount}
        </Text>{' '}
        to you
      </SmallTitle>
      <StandardText>
        It will be securely added to your bank. We don’t accept prepaid, credit,
        or international cards.
      </StandardText>
    </ClaimInfoBase>
  );
};

export default PayAnyoneClaimInfo;
